import { render } from "./DocumentListing.vue?vue&type=template&id=45b7f0c5"
import script from "./DocumentListing.vue?vue&type=script&lang=js"
export * from "./DocumentListing.vue?vue&type=script&lang=js"

import "./DocumentListing.vue?vue&type=style&index=0&id=45b7f0c5&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__